import styled from "styled-components";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const SPLIT_BILL_SUBTITLE_WIDTH = "176px";
const SPLIT_BILL_SUCCESS_SUBTITLE_WIDTH = "180px";
const SPLIT_BILL_IMAGE_WIDTH = "127px";
const SPLIT_BILL_SUCCESS_ICON_SIZE = "20px";

export const SplitBillWrapper = styled.div<{
    backgroundColor?: keyof IColors;
    isClickable?: boolean;
}>(({ theme, backgroundColor, isClickable }) => ({
    display: "flex",
    position: "relative",
    justifyContent: "space-between",
    cursor: isClickable ? "pointer" : "default",
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    borderRadius: theme.cornerRadius.medium,
    backgroundColor: backgroundColor
        ? theme.colors[theme.colorMode][backgroundColor]
        : theme.colors[theme.colorMode].background_Primary,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: 2, // this is needed to ensure the widget is on top of the background image
}));

export const SplitBillContentWrapper = styled.div(({ theme }) => ({
    padding: theme.spacing.small,
    paddingRight: theme.spacing.small,
    flex: 1,
    minWidth: 0,
}));

export const SplitBillTitleWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const SplitBillSubTitleWrapper = styled.div<{ isSuccessState?: boolean }>(({ theme, isSuccessState }) => ({
    width: isSuccessState ? SPLIT_BILL_SUCCESS_SUBTITLE_WIDTH : SPLIT_BILL_SUBTITLE_WIDTH,
    marginTop: theme.spacing.xxSmall,
}));

export const SplitBillCta = styled.div(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    marginTop: theme.spacing.xSmall,
}));

export const SplitBillCtaIcon = styled.span({
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
});

export const SplitBillSuccessIconWrap = styled.div({
    flexShrink: 0,
    width: SPLIT_BILL_SUCCESS_ICON_SIZE,
    height: SPLIT_BILL_SUCCESS_ICON_SIZE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const SplitBillImageContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    width: SPLIT_BILL_IMAGE_WIDTH,
    marginRight: theme.spacing.xSmall,
    flexShrink: 0,
}));
